import { createElementBlock as t, openBlock as e, createElementVNode as l } from "vue";
import r from "./index289.js";
const a = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s(c, o, p, m, i, f) {
  return e(), t("svg", n, o[0] || (o[0] = [
    l("path", {
      fill: "currentColor",
      d: "M19.75 4.25a3.417 3.417 0 1 1-5.066 4.576l-4.7 2.35c.133.54.133 1.107 0 1.648l4.7 2.35a3.417 3.417 0 1 1-.67 1.342l-4.702-2.352a3.417 3.417 0 1 1 0-4.327l4.703-2.353A3.417 3.417 0 0 1 19.75 4.25Zm-3.772 11.727c-.12.12-.22.251-.302.391a.755.755 0 0 1-.108.221 1.917 1.917 0 1 0 3.238-.483l-.117-.129-.13-.117a1.917 1.917 0 0 0-2.581.117ZM5.31 10.644a1.917 1.917 0 1 0 3.016 2.315.64.64 0 0 1 .042-.104l.058-.097.046-.114a1.924 1.924 0 0 0-.046-1.404.756.756 0 0 1-.101-.199 1.822 1.822 0 0 0-.186-.268l-.117-.129-.13-.117a1.917 1.917 0 0 0-2.582.117Zm10.667-5.333a1.918 1.918 0 0 0-.412 2.101.755.755 0 0 1 .111.219 1.917 1.917 0 1 0 3.129-2.19l-.117-.13-.13-.117a1.917 1.917 0 0 0-2.581.117Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ r(a, [["render", s]]);
export {
  u as default
};
